function findAll(root, selector) {
  const found = Array.from(root.querySelectorAll(selector));
  return root.matches && root.matches(selector) ? [root, ...found] : found;
}

export function findBlocks(root, selector) {
  return findAll(root, selector);
}

export function isBlockEditor() {
  return Boolean(window.acf)
    && document.body.classList.contains('block-editor-page');
}

export function bootBlock(slug, init) {
  if (isBlockEditor()) {
    window.acf.addAction(`render_block_preview/type=${slug}`, ($block) => {
      init($block.get(0), { isEditor: true });
    });
    return;
  }

  const run = () => init(document, { isEditor: false });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}
